<div class="d-flex justify-content-end gap-1 align-items-center">
  <mat-label *ngIf="date" class="date small">{{
    date | date: "short"
  }}</mat-label>

  <mat-label class="initials" *ngIf="initials">{{ initials }}</mat-label>
</div>
